{
  "version": 1,
  "weeks": {
    "2026-10-02": {
      "title": "Make room for what we do not know",
      "intro": "Ownership, resemblance, and uncertain births: this week asks us to separate what we know from what we can only suppose.",
      "paragraphs": [
        "At the end of this week’s learning, a small distinction carries a great deal of weight: knowing that a firstborn exists is not always the same as knowing which animal it is. In Bekhorot 2:7–8, the mothers’ birth histories change what can be established. The Mishnah keeps the animal’s possible sacred status separate from the question of what the priest can claim.",
        "Earlier in the week, Bekhorot 2:4 asked us to trace an ownership interest across generations. Bekhorot 2:5 examined resemblance to the mother’s kind. Together, these lessons ask for careful attention: who has a claim, which facts identify the animal, and which facts remain unresolved? A confident first impression cannot do all that work.",
        "For our Shabbat-table reflection, carry that patience into conversation. When someone tells a story, can we listen long enough to distinguish what happened from what we assumed? This is a personal application inspired by the learning, not the Mishnah’s legal ruling. We can care deeply and still leave room to say, ‘I don’t know yet.’"
      ],
      "family": "Can you remember a time when learning one more detail changed your mind?",
      "deeper": "How can we act responsibly when an important fact remains uncertain?",
      "takeaway": "Leave room for one more detail before reaching a conclusion.",
      "sources": [
        "Mishnah Bekhorot 2:4",
        "Mishnah Bekhorot 2:5",
        "Mishnah Bekhorot 2:7",
        "Mishnah Bekhorot 2:8"
      ],
      "lessons": [
        {
          "date": "2026-09-28",
          "ref": "Bekhorot 2:4",
          "title": "An ownership interest across generations",
          "sourcePath": "data/m72/lessons/2878.json"
        },
        {
          "date": "2026-09-29",
          "ref": "Bekhorot 2:5",
          "title": "Resemblance and the firstborn category",
          "sourcePath": "data/m72/lessons/2879.json"
        },
        {
          "date": "2026-09-30",
          "ref": "Bekhorot 2:6",
          "title": "Two males, one ewe, and three separate disputes",
          "sourcePath": "data/m72/lessons/2880.json"
        },
        {
          "date": "2026-10-01",
          "ref": "Bekhorot 2:7",
          "title": "Two mothers: count what must be true",
          "sourcePath": "data/m72/lessons/2881.json"
        },
        {
          "date": "2026-10-02",
          "ref": "Bekhorot 2:8",
          "title": "Two mothers with different birth histories",
          "sourcePath": "data/m72/lessons/2882.json"
        }
      ],
      "editorialNote": "Original editorial reflection based on the listed local lessons. Reflection is distinguished from the source’s legal teaching."
    },
    "2026-10-09": {
      "title": "Look carefully. Then look again.",
      "intro": "From the meaning of “first” to the wool that has separated from an animal, this week rewards precise observation.",
      "paragraphs": [
        "What does it mean to be first? Bekhorot 2:9 separates being the first offspring born from being the first to open the womb. Those descriptions can belong to different animals. The wording matters because each description points to a different fact.",
        "The next lessons ask what counts as evidence of an earlier birth and what we may infer from a nursing relationship. Then the Mishnah turns to hair moved aside for a blade and wool that has come loose. In each case, we must identify the actual relationship or event before deciding what follows from it. Similar-looking situations may carry different consequences.",
        "For the Shabbat table, let that attentiveness become a way of noticing people. A quick description—‘quiet,’ ‘difficult,’ or ‘always busy’—rarely tells a whole story. Ask one curious question before settling on a label. This is our reflection inspired by the week’s learning, rather than a legal conclusion drawn from these laws."
      ],
      "family": "What is something you noticed this week that you had never noticed before?",
      "deeper": "When does a useful label stop helping us understand a person or situation?",
      "takeaway": "Attention begins where the quick label ends.",
      "sources": [
        "Mishnah Bekhorot 2:9",
        "Mishnah Bekhorot 3:1",
        "Mishnah Bekhorot 3:2",
        "Mishnah Bekhorot 3:3",
        "Mishnah Bekhorot 3:4"
      ],
      "lessons": [
        {
          "date": "2026-10-05",
          "ref": "Bekhorot 2:9",
          "title": "First to be born, first to open the womb",
          "sourcePath": "data/m72/lessons/2883.json"
        },
        {
          "date": "2026-10-06",
          "ref": "Bekhorot 3:1",
          "title": "What counts as evidence of an earlier birth?",
          "sourcePath": "data/m72/lessons/2884.json"
        },
        {
          "date": "2026-10-07",
          "ref": "Bekhorot 3:2",
          "title": "Read the nursing relationship without inventing a swap",
          "sourcePath": "data/m72/lessons/2885.json"
        },
        {
          "date": "2026-10-08",
          "ref": "Bekhorot 3:3",
          "title": "Make room for the blade without shearing",
          "sourcePath": "data/m72/lessons/2886.json"
        },
        {
          "date": "2026-10-09",
          "ref": "Bekhorot 3:4",
          "title": "Shed wool: which event ends the restriction?",
          "sourcePath": "data/m72/lessons/2887.json"
        }
      ],
      "editorialNote": "Original editorial reflection based on the listed local lessons. Reflection is distinguished from the source’s legal teaching."
    }
  }
}
